import _objectSpread from "/var/lib/jenkins/workspace/staging_gift_admin_deploy/node_modules/.pnpm/@babel+runtime@7.29.2/node_modules/@babel/runtime/helpers/esm/objectSpread2.js";
import _regenerator from "/var/lib/jenkins/workspace/staging_gift_admin_deploy/node_modules/.pnpm/@babel+runtime@7.29.2/node_modules/@babel/runtime/helpers/esm/regenerator.js";
import _asyncToGenerator from "/var/lib/jenkins/workspace/staging_gift_admin_deploy/node_modules/.pnpm/@babel+runtime@7.29.2/node_modules/@babel/runtime/helpers/esm/asyncToGenerator.js";
import "core-js/modules/es.array.concat.js";
import "core-js/modules/es.array.filter.js";
import "core-js/modules/es.array.includes.js";
import "core-js/modules/es.array.join.js";
import "core-js/modules/es.array.map.js";
import "core-js/modules/es.array.sort.js";
import "core-js/modules/es.array.splice.js";
import "core-js/modules/es.function.name.js";
import "core-js/modules/es.iterator.constructor.js";
import "core-js/modules/es.iterator.filter.js";
import "core-js/modules/es.iterator.map.js";
import "core-js/modules/es.number.constructor.js";
import "core-js/modules/es.number.to-fixed.js";
import "core-js/modules/es.object.keys.js";
import "core-js/modules/es.object.to-string.js";
import "core-js/modules/es.regexp.exec.js";
import "core-js/modules/es.string.includes.js";
import "core-js/modules/es.string.replace.js";
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import { getStoreCitys, getCakeHomeBrandsList as _getCakeHomeBrandsList } from '@/api/goodsCenter';
import { cakeBrands, exportCakeData, exportCakeGoodsData, exportCakeSkuData, getCakeCategory, getCakeHomeBrands, getCommonCakeHomeBrands as _getCommonCakeHomeBrands, getCakeTodoorGoods, getCakeTodoorSkus } from '@/api/order';
export default {
  name: 'cakeConfig',
  props: {
    order_id: [Number, String],
    currentRowMenu: {
      type: Object,
      default: function _default() {
        return {};
      }
    },
    ruleType: String,
    entryType: String,
    // 平台配置  渠道列表 管理中心 订单规则
    /**
     * @description menuType 菜单类型
     * orderDetails - 订单列表-订单详情-订单规则
     * channelCardTypeManage - 管理中心 卡类型管理
     * saleCardTypeManage - 销售工具 卡类型管理
     * customerSet - 客户管理 - 客户列表 - 设置 - 营销参数管理
     */
    menuType: String,
    cakeType: String,
    // view - 查看 没有编辑功能  set - 允许编辑
    ruleInfo: {
      type: Object,
      default: function _default() {
        return {};
      }
    },
    menusInfo: {
      type: Object,
      default: function _default() {
        return {};
      }
    },
    hasEditRule: Boolean,
    cakeWhiteTotal: Number
  },
  data: function data() {
    return {
      activeName: '0',
      blockBrandTotal: 0,
      // 订单级黑名单品牌总数

      citys: [],
      categoryList: [],
      brandList: [],
      searchForm: {
        region_id: '',
        category_id: '',
        brand_name: '',
        page: 1,
        pagesize: 20
      },
      goodsForm: {
        region_id: '',
        brand_code: '',
        product_name: '',
        is_today_on: '',
        category_id: '',
        page: 1,
        pagesize: 20
      },
      skuForm: {
        region_id: '',
        goods_id: '',
        brand_code: '',
        product_name: '',
        profit_ratio_gt: this.$route.query.profit_ratio_gt || '',
        // 最低
        profit_ratio_lt: '',
        // 最高
        category_id: '',
        sku_name: '',
        price_range: ['', ''],
        clearing_range: ['', ''],
        page: 1,
        pagesize: 20
      },
      searchForm_total: 0,
      goodsForm_total: 0,
      skuForm_total: 0,
      tableData: [],
      // city tree dialog start
      showCityDialog: false,
      cityList: [],
      filterText: '',
      // city tree dialog end

      exportLoading: false,
      exportGoodsLoading: false,
      exportSkuLoading: false,
      // 客户级利润率表单 start
      profitCustomerForm: {
        unmetTotal: 0,
        ratio: '',
        account_id: '',
        adjust_id: '',
        adjust_type: [],
        by_money_adjust: '',
        by_ratio_adjust: ''
      },
      // 客户级利润率表单 end

      menuDialog: false,
      menuDialogForm: {
        region_id: '',
        category_id: '',
        brand_name: '',
        page: 1,
        pagesize: 20,
        total_count: 0
      },
      menuTotal: 0,
      // 菜单级规则 可用品牌数
      menuBrandList: [],
      dialogType: '',
      // 品牌黑名单 start
      cakeDialog: false,
      cakeList: [],
      checkedCakes: [],
      tempCakes: [],
      searchBrand: {
        brand_name: '',
        page: 1,
        pagesize: 20,
        total_count: 0
      },
      // 品牌黑名单 end
      skuList: [],
      goodList: [],
      status: [{
        name: '是',
        value: '1'
      }, {
        name: '否',
        value: '0'
      }]
    };
  },
  created: function created() {
    var _this = this;
    return _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee() {
      return _regenerator().w(function (_context) {
        while (1) switch (_context.n) {
          case 0:
            _this.getCakeHomeBrandsList();
            _this.getConfig();
            _this.loadData();
          case 1:
            return _context.a(2);
        }
      }, _callee);
    }))();
  },
  methods: {
    getCityBrand: function getCityBrand(val) {
      this.brandList = [];
      if (this.activeName === '1') {
        this.goodsForm.brand_code = '';
      }
      if (this.activeName === '2') {
        this.skuForm.brand_code = '';
      }
      this.getCakeHomeBrandsList(val);
    },
    getCakeHomeBrandsList: function getCakeHomeBrandsList() {
      var _this2 = this;
      var region_id = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : '';
      _getCakeHomeBrandsList({
        region_id: region_id
      }).then(function (res) {
        _this2.brandList = res.data.data;
      });
    },
    tabChange: function tabChange(tab) {
      this.activeName = tab.name;
      this.loadTabData(tab.name);
      this.getCakeHomeBrandsList();
    },
    loadTabData: function loadTabData(name) {
      switch (name) {
        case '0':
          this.searchForm.page = 1;
          this.getList(_objectSpread({
            type: 'allow_brand'
          }, this.searchForm), true);
          break;
        case '1':
          this.goodsForm.page = 1;
          this.loadGoodsData();
          break;
        case '2':
          this.skuForm.page = 1;
          this.loadSkuData();
          break;
      }
    },
    loadGoodsData: function loadGoodsData() {
      var _this3 = this;
      getCakeTodoorGoods(_objectSpread(_objectSpread(_objectSpread({}, this.ruleType === 'cardType' ? {
        rule_id: this.ruleInfo.id
      } : {
        order_id: this.order_id
      }), this.goodsForm), {}, {
        menu_id: this.currentRowMenu.id,
        type: 'allow_brand'
      })).then(function (res) {
        var _res$data = res.data,
          _res$data$data = _res$data.data,
          data = _res$data$data === void 0 ? [] : _res$data$data,
          _res$data$pages = _res$data.pages,
          pages = _res$data$pages === void 0 ? {} : _res$data$pages;
        _this3.goodList = data;
        _this3.goodsForm_total = pages.total_count || 0;
      });
    },
    sortGoodsChange: function sortGoodsChange(val) {
      this.goodsForm.sort = val.order;
      this.goodsForm.sortParam = val.order ? val.prop : null;
      this.loadGoodsData();
    },
    loadSkuData: function loadSkuData() {
      var _this4 = this;
      getCakeTodoorSkus(_objectSpread(_objectSpread(_objectSpread({}, this.ruleType === 'cardType' ? {
        rule_id: this.ruleInfo.id
      } : {
        order_id: this.order_id
      }), this.skuForm), {}, {
        menu_id: this.currentRowMenu.id,
        type: 'allow_brand'
      })).then(function (res) {
        var _res$data2 = res.data,
          _res$data2$data = _res$data2.data,
          data = _res$data2$data === void 0 ? [] : _res$data2$data,
          _res$data2$pages = _res$data2.pages,
          pages = _res$data2$pages === void 0 ? {} : _res$data2$pages;
        _this4.skuList = data;
        _this4.skuForm_total = pages.total_count || 0;
      });
    },
    sortSkuChange: function sortSkuChange(val) {
      this.skuForm.sort = val.order;
      this.skuForm.sortParam = val.order ? val.prop : null;
      this.loadSkuData();
    },
    searchGoodeData: function searchGoodeData() {
      this.goodsForm.page = 1;
      this.loadGoodsData();
    },
    searchSkuData: function searchSkuData() {
      this.skuForm.page = 1;
      this.loadSkuData();
    },
    pageChangeGoods: function pageChangeGoods() {
      var page = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 1;
      this.goodsForm.page = page;
      this.loadGoodsData();
    },
    pageChangeSku: function pageChangeSku() {
      var page = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 1;
      this.skuForm.page = page;
      this.loadSkuData();
    },
    sizeChangeGoods: function sizeChangeGoods(size) {
      this.goodsForm.pagesize = size;
      this.loadGoodsData();
    },
    sizeChangeSku: function sizeChangeSku(size) {
      this.skuForm.pagesize = size;
      this.loadSkuData();
    },
    sizeChangeSearch: function sizeChangeSearch(size) {
      this.searchForm.pagesize = size;
      this.getList(_objectSpread({
        type: 'allow_brand'
      }, this.searchForm), true);
    },
    pageChangeSearch: function pageChangeSearch() {
      var page = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 1;
      this.searchForm.page = page;
      this.getList(_objectSpread({
        type: 'allow_brand'
      }, this.searchForm), true);
    },
    showMore: function showMore(row) {
      this.$set(row, 'showMore', !row.showMore);
    },
    setBlackCake: function setBlackCake() {
      var _this5 = this;
      if (this.dialogType !== 'setBlack') {
        return;
      }
      this.$emit('setBlackCake', {
        selectIds: this.checkedCakes.map(function (i) {
          return i.id;
        }),
        showMsg: false,
        cb: function cb() {
          _this5.getBlockBrandTotal();
          _this5.pageChangeSearch(1);
          _this5.$message.success('操作成功');
          _this5.cakeDialog = false;
        }
      });
    },
    selectable: function selectable(row) {
      var selectIds = this.checkedCakes.map(function (item) {
        return item.id;
      });
      return selectIds.indexOf(row.id) === -1;
    },
    handleSelectCake: function handleSelectCake(val) {
      this.tempCakes = val;
    },
    batchAddCake: function batchAddCake() {
      this.checkedCakes = this.checkedCakes.concat(this.tempCakes);
      this.tempCakes = [];
      this.$refs.multipleTable.clearSelection();
    },
    // 管理中心获取蛋糕到家数据
    getCommonCakeHomeBrands: function getCommonCakeHomeBrands(isInit) {
      var _this6 = this;
      _getCommonCakeHomeBrands(_objectSpread(_objectSpread({}, this.searchBrand), {}, {
        rule_id: this.ruleInfo.id,
        category_id: this.currentRowMenu.id
      })).then(function (res) {
        var data = res.data,
          pages = res.pages;
        _this6.cakeList = data.list;
        _this6.searchBrand.total_count = pages.totalCount || 0;
        if (isInit) {
          _this6.checkedCakes = data.brands;
        }
      });
    },
    getCakeList: function getCakeList(isInit) {
      var _this7 = this;
      getCakeHomeBrands(_objectSpread(_objectSpread({}, this.searchBrand), {}, {
        order_id: this.order_id,
        category_id: this.currentRowMenu.id
      })).then(function (res) {
        var data = res.data,
          pages = res.pages;
        _this7.cakeList = data.list;
        _this7.searchBrand.total_count = pages.totalCount || 0;
        if (isInit) {
          _this7.checkedCakes = data.brands;
        }
      });
    },
    // 设置品牌黑名单 start
    searchCakeList: function searchCakeList() {
      var page = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 1;
      var isInit = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : false;
      this.searchBrand.page = page;
      if (isInit) {
        this.checkedCakes = [];
        this.cakeList = [];
        this.searchBrand.brand_name = '';
      }
      if (this.ruleType === 'cardType') {
        this.getCommonCakeHomeBrands(isInit);
      } else {
        this.getCakeList(isInit);
      }
    },
    delCheckedCake: function delCheckedCake(index) {
      if (this.dialogType !== 'setBlack') {
        return;
      }
      this.checkedCakes.splice(index, 1);
    },
    clearChecked: function clearChecked() {
      this.checkedCakes = [];
    },
    // 设置品牌黑名单 end
    // 菜单级规则 start
    searchMenuList: function searchMenuList() {
      var _this$$refs$menuDialo;
      var page = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 1;
      var props = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
      var type = props.type;
      type === 'reset' && ((_this$$refs$menuDialo = this.$refs.menuDialogForm) === null || _this$$refs$menuDialo === void 0 ? void 0 : _this$$refs$menuDialo.resetFields());
      this.menuDialogForm.page = page;
      this.getMenuBrandList();
    },
    getMenuBrandList: function getMenuBrandList() {
      var _this8 = this;
      var setData = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : true;
      // 菜单级规则 明细 & 可用品牌数
      this.getList(_objectSpread({
        type: 'menu_allow_brand'
      }, setData ? this.menuDialogForm : {})).then(function (res) {
        var _res$data3 = res.data,
          data = _res$data3 === void 0 ? [] : _res$data3,
          menu_pages = res.pages;
        if (setData) {
          _this8.menuBrandList = data;
          _this8.menuDialogForm.total_count = menu_pages.total_count || 0;
        } else {
          _this8.menuTotal = menu_pages.total_count || 0;
        }
      });
    },
    getBlockBrandTotal: function getBlockBrandTotal() {
      var _this9 = this;
      this.getList({
        type: 'not_allow_brand'
      }).then(function (data) {
        var block_pages = data.pages;
        _this9.blockBrandTotal = block_pages.total_count || 0;
      });
    },
    // 菜单级规则 end
    loadData: function loadData() {
      var _this0 = this;
      return _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee2() {
        return _regenerator().w(function (_context2) {
          while (1) switch (_context2.n) {
            case 0:
              // 初始化时请求3个接口获取总数
              _this0.getList(_objectSpread({
                type: 'allow_brand'
              }, _this0.searchForm), true);
              _this0.loadGoodsData();
              _this0.loadSkuData();
              _this0.getMenuBrandList(false); // 菜单级规则 可用品牌数
              _this0.getBlockBrandTotal(); // 订单级黑名单品牌数
              // 客户级规则 不满足利润率SKU数量 start
              _this0.getList({
                type: 'all_not',
                region_id: 999999
              }).then(function (res) {
                var custom_pages = res.pages;
                _this0.profitCustomerForm = _objectSpread(_objectSpread({}, _this0.profitCustomerForm), {}, {
                  unmetTotal: custom_pages.total_count || 0
                });
              });
              // 客户级规则 不满足利润率SKU数量 end
            case 1:
              return _context2.a(2);
          }
        }, _callee2);
      }))();
    },
    getList: function getList() {
      var _this1 = this;
      var params = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
      var isSetData = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : false;
      return new Promise(function (resolve) {
        cakeBrands(_objectSpread(_objectSpread(_objectSpread({}, _this1.ruleType === 'cardType' ? {
          rule_id: _this1.ruleInfo.id
        } : {
          order_id: _this1.order_id
        }), params), {}, {
          menu_id: _this1.currentRowMenu.id
        }), _this1.menuType // 如果是查看客户级黑名单明细弹窗 强制传customerSet菜单类型
        ).then(function (res) {
          var _res$data4 = res.data,
            _res$data4$data = _res$data4.data,
            data = _res$data4$data === void 0 ? [] : _res$data4$data,
            _res$data4$pages = _res$data4.pages,
            pages = _res$data4$pages === void 0 ? {} : _res$data4$pages,
            _res$data4$extend_dat = _res$data4.extend_data,
            extend_data = _res$data4$extend_dat === void 0 ? {} : _res$data4$extend_dat;
          if (isSetData) {
            _this1.tableData = data;
            _this1.totalCount = pages.total_count || 0;
            _this1.searchForm_total = pages.total_count || 0;

            // 设置客户级规则利润率
            var _extend_data$settings = extend_data.settings,
              settings = _extend_data$settings === void 0 ? {} : _extend_data$settings,
              _extend_data$adjustIn = extend_data.adjustInfo,
              adjustInfo = _extend_data$adjustIn === void 0 ? {} : _extend_data$adjustIn;
            var cake_profit_rate_control = settings.cake_profit_rate_control,
              _settings$cake_profit = settings.cake_profit_rate,
              cake_profit_rate = _settings$cake_profit === void 0 ? '' : _settings$cake_profit,
              _settings$channel_cak = settings.channel_cake_profit_rate,
              channel_cake_profit_rate = _settings$channel_cak === void 0 ? '' : _settings$channel_cak,
              account_id = settings.account_id;
            var adjust_id = adjustInfo.id,
              _adjustInfo$adjust_ty = adjustInfo.adjust_type,
              adjust_type = _adjustInfo$adjust_ty === void 0 ? '' : _adjustInfo$adjust_ty,
              by_money_adjust = adjustInfo.by_money_adjust,
              by_ratio_adjust = adjustInfo.by_ratio_adjust; //客户级调价规则
            _this1.profitCustomerForm = _objectSpread(_objectSpread({}, _this1.profitCustomerForm), {}, {
              ratio: {
                0: channel_cake_profit_rate,
                1: cake_profit_rate
              }[cake_profit_rate_control] || '',
              account_id: account_id,
              adjust_id: adjust_id,
              adjust_type: adjust_type.split(',') || [],
              by_money_adjust: by_money_adjust,
              by_ratio_adjust: by_ratio_adjust
            });
          }
          resolve(res.data);
        });
      });
    },
    searchData: function searchData(type) {
      // 根据当前 activeName 调用对应搜索
      if (this.activeName === '0') {
        var _this$$refs$searchFor;
        type === 'reset' && ((_this$$refs$searchFor = this.$refs.searchForm) === null || _this$$refs$searchFor === void 0 ? void 0 : _this$$refs$searchFor.resetFields());
        this.pageChangeSearch();
      } else if (this.activeName === '1') {
        var _this$$refs$goodsForm;
        type === 'reset' && ((_this$$refs$goodsForm = this.$refs.goodsForm) === null || _this$$refs$goodsForm === void 0 ? void 0 : _this$$refs$goodsForm.resetFields());
        this.searchGoodeData();
      } else if (this.activeName === '2') {
        var _this$$refs$skuForm;
        type === 'reset' && ((_this$$refs$skuForm = this.$refs.skuForm) === null || _this$$refs$skuForm === void 0 ? void 0 : _this$$refs$skuForm.resetFields());
        this.searchSkuData();
      }
    },
    // 仅允许输入数字和一个小数点，写回对应数组位置
    onNumberInput: function onNumberInput(field, index, val) {
      var v = String(val || '');
      // 去除非数字和小数点
      v = v.replace(/[^\d.]/g, '');
      // 只保留第一个小数点
      var parts = v.split('.');
      if (parts.length > 1) {
        v = parts.shift() + '.' + parts.join('');
      }
      // 去除开头多余的点
      v = v.replace(/^\./, '');
      // 保证数组存在
      if (!this.skuForm[field]) {
        this.$set(this.skuForm, field, ['', '']);
      }
      // 写回指定索引
      this.$set(this.skuForm[field], index, v);
    },
    // 查看覆盖城市 start
    onClose: function onClose() {
      this.filterText = '';
    },
    filterNode: function filterNode(value, data) {
      if (!value) return true;
      return data.label.indexOf(value) !== -1;
    },
    openCityDialog: function openCityDialog(citys) {
      this.cityList = citys;
      this.showCityDialog = true;
    },
    // 查看覆盖城市 end
    exportData: function exportData() {
      var _this10 = this;
      this.exportLoading = true;
      exportCakeData(_objectSpread(_objectSpread(_objectSpread({}, this.ruleType === 'cardType' ? {
        rule_id: this.ruleInfo.id
      } : {
        order_id: this.order_id
      }), this.searchForm), {}, {
        type: 'allow_brand',
        menu_id: this.currentRowMenu.id,
        action: this.cakeType === 'set' ? 'set' : 'show'
      }), this.menuType).then(function (_) {
        _this10.$message.warning('开始生成文件，请在【下载中心】查看进度并下载文件到本地');
      }).finally(function () {
        _this10.exportLoading = false;
      });
    },
    /**
     * 导出可用商品
     */
    exportCakeHomeGoods: function exportCakeHomeGoods() {
      var _this11 = this;
      this.exportGoodsLoading = true;
      exportCakeGoodsData(_objectSpread(_objectSpread(_objectSpread({}, this.ruleType === 'cardType' ? {
        rule_id: this.ruleInfo.id
      } : {
        order_id: this.order_id
      }), this.goodsForm), {}, {
        menu_id: this.currentRowMenu.id,
        type: 'allow_brand',
        action: this.cakeType === 'set' ? 'set' : 'show'
      }), this.menuType).then(function (_) {
        _this11.$message.warning('开始生成文件，请在【下载中心】查看进度并下载文件到本地');
      }).finally(function () {
        _this11.exportGoodsLoading = false;
      });
    },
    /**
     * 导出可用SKU
     */
    exportCakeHomeSku: function exportCakeHomeSku() {
      var _this12 = this;
      this.exportSkuLoading = true;
      exportCakeSkuData(_objectSpread(_objectSpread(_objectSpread({}, this.ruleType === 'cardType' ? {
        rule_id: this.ruleInfo.id
      } : {
        order_id: this.order_id
      }), this.skuForm), {}, {
        menu_id: this.currentRowMenu.id,
        type: 'allow_brand',
        action: this.cakeType === 'set' ? 'set' : 'show'
      }), this.menuType).then(function (_) {
        _this12.$message.warning('开始生成文件，请在【下载中心】查看进度并下载文件到本地');
      }).finally(function () {
        _this12.exportSkuLoading = false;
      });
    },
    sizeChange: function sizeChange(formName, size) {
      this[formName].pagesize = size;
      if (formName === 'menuDialogForm') {
        this.searchMenuList();
      } else if (formName === 'searchBrand') {
        this.searchCakeList();
      } else {
        this.pageChangeSearch();
      }
    },
    openDialog: function openDialog(openType) {
      this.dialogType = openType;
      switch (openType) {
        case 'menus':
          this.searchMenuList();
          this.menuDialog = true;
          break;
        case 'customer':
          var profit_ratio_gt = (100 - this.profitCustomerForm.ratio) / 10;
          var src = "".concat(this.$store.state.user.domainName, "/#/goodsCenter/cakeToHome?activeName=sku&profit_ratio_gt=").concat(profit_ratio_gt.toFixed(2));
          window.open(src, '_blank');
          break;
        case 'setBlack':
        case 'viewBlack':
          this.searchCakeList(1, true);
          this.cakeDialog = true;
          break;
        case 'setCakeWhite':
        case 'viewCakeWhite':
          this.$emit('openWhiteCity', 1, openType, this.currentRowMenu);
          break;
        case 'setCakeChild':
        case 'viewCakeChild':
          this.$emit('setChildMenu', this.currentRowMenu.childrens, this.currentRowMenu, {
            openType: openType
          });
          break;
      }
    },
    getConfig: function getConfig() {
      var _this13 = this;
      getCakeCategory({
        menu_id: this.currentRowMenu.id
      }).then(function (res) {
        _this13.categoryList = res.data.data;
      });
      getStoreCitys().then(function (res) {
        _this13.citys = res.data.tree;
      });
    }
  },
  watch: {
    filterText: function filterText(val) {
      this.$refs.tree.filter(val);
    }
  },
  computed: {
    childMenuTotal: function childMenuTotal() {
      var _this$currentRowMenu$ = this.currentRowMenu.childrens,
        childrens = _this$currentRowMenu$ === void 0 ? [] : _this$currentRowMenu$;
      return childrens.filter(function (i) {
        return i.selected == 1;
      }).length;
    },
    /**
     * 可用品牌导出权限
     */
    hasExportRole: function hasExportRole() {
      var authEnum = {
        orderDetails: '/orders/card-rule-extend/cake-todoor-brands-v2-export',
        channelCardTypeManage: '/orders/card-rule-extend/cake-todoor-brands-v2-common-export',
        saleCardTypeManage: '/orders/card-rule-extend/cake-todoor-brands-v2-sale-export'
      };
      var keys = Object.keys(authEnum);
      if (keys.includes(this.menuType)) {
        // 产品要求 只需要在这三个页面中判断权限即可
        var rolePath = authEnum[this.menuType];
        return this.$hasBtnRoles(rolePath);
      }
      return false;
    },
    /**
     * 可用商品导出权限
     */
    hasExportRoleGoods: function hasExportRoleGoods() {
      var authEnum = {
        orderDetails: '/orders/card-rule-extend/cake-todoor-brands-v2-export',
        channelCardTypeManage: '/orders/card-rule-extend/cake-todoor-brands-v2-common-export',
        saleCardTypeManage: '/orders/card-rule-extend/cake-todoor-brands-v2-sale-export'
      };
      var keys = Object.keys(authEnum);
      if (keys.includes(this.menuType)) {
        var rolePath = authEnum[this.menuType];
        return this.$hasBtnRoles(rolePath);
      }
      return false;
    },
    /**
     * 可用SKU导出权限
     */
    hasExportRoleSku: function hasExportRoleSku() {
      var authEnum = {
        orderDetails: '/orders/card-rule-extend/cake-todoor-brands-v2-export',
        channelCardTypeManage: '/orders/card-rule-extend/cake-todoor-brands-v2-common-export',
        saleCardTypeManage: '/orders/card-rule-extend/cake-todoor-brands-v2-sale-export'
      };
      var keys = Object.keys(authEnum);
      if (keys.includes(this.menuType)) {
        var rolePath = authEnum[this.menuType];
        return this.$hasBtnRoles(rolePath);
      }
      return false;
    }
  }
};